import React from "react";
import { Field } from "redux-form";
import { FormGroup, Label } from "reactstrap";

import Repeater from "../../../system/fields/Repeater";
import DatePickerInput from "../../../system/fields/DatePicker";
import * as validations from "../../../system/utils/Validation";
import TextInput from '../../../system/fields/TextInput';
import Wysiwyg from "../../../system/fields/Wysiwyg";
import FileUpload from "../../../system/fields/FileUpload";

class ExcursionsWrapper extends React.Component {
  constructor(props, excursion, index, fields) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: true };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  render() {
    return (
      <Repeater key={this.props.index}>
        <div className="toolbar">
        <i className="far fa-trash-alt" onClick={() => this.props.fields.remove(this.props.index)} />
        </div>
        <div className="row top-field">
          <FormGroup className="col-12 col-sm-6">
            <Label>Excursion Title</Label>
            <Field
              name={`${this.props.excursion}.excursion_title`}
              component={TextInput}
              type="text"
            />
          </FormGroup>
          <FormGroup className="col-12 col-sm-6">
            <Label>Excursion Price</Label>
            <Field
              name={`${this.props.excursion}.excursion_price`}
              component={TextInput}
              type="text"
            />
          </FormGroup>
          <FormGroup className="col-12 col-sm-6">
            <Label>Excursion Summary</Label>
            <Field
              name={`${this.props.excursion}.excursion_summary`}
              component={Wysiwyg}
              type="text"
            />
          </FormGroup>
          <FormGroup className="col-12 col-sm-6">
            <Label>Excursion Image</Label>
            <Field
              name={`${this.props.excursion}.excursion_image`}
              component={FileUpload}
              type="text"
              image
            />
          </FormGroup>
        </div>
      </Repeater>
    );
  }
}

export default ExcursionsWrapper;



// WEBPACK FOOTER //
// ./src/containers/Bookings/components/ExcursionsWrapper.jsx